export const RouteLinks = {
  PostImage: '/post-image',
};
